export const API_TEXT = 'API'